<template>
  <div>
    <template v-if="hospital">
      <div class="panel wraper panel-gray">
        <div class="panel-header">
          <transition :name="transName || 'slide-l'" mode="out-in">
            <div class="panel-title" :key="$route.params.id">{{hospital.label}}</div>
          </transition>
        </div>
        <transition :name="transName || 'slide-l'" mode="out-in">
          <div class="panel-body" :key="$route.params.id">
            <p v-if="hospital.lastEdited" class="in-top">
              <small class="view-label">
                <q-icon name="fas fa-user-edit"/> {{editor}} {{hospital.lastEdited | formatTime}}
              </small>
            </p>
            <p v-if="hospital.abbr">
              <small class="view-label">Назв.сокр-ное</small>
              <span class="text-bolder">{{hospital.abbr}}</span>
            </p>
            <p v-if="hospital.fullName">
              <small class="view-label">Название</small>
              <span class="text-bolder">{{hospital.fullName}}</span>
            </p>
            <p v-if="hospital.city">
              <small class="view-label">Город</small>
              <span class="text-bolder">{{hospital.city}}</span>
            </p>
            <p v-if="hospital.address">
              <small class="view-label">Адрес</small>
              <span>{{hospital.address}}</span>
            </p>
            <p v-if="formatTel">
              <small class="view-label">Контакты</small>
              <span class="text-bolder" v-html="formatTel"></span>
            </p>
            <p v-if="hospital.comment">
              <small class="view-label">Заметки</small>
              <span class="text-bolder">{{hospital.comment}}</span>
            </p>
            <media-bar :medias="mediasCopy" @selectMedia="showAttach"></media-bar>
            <div class="panel panel-gray">
              <q-tree
                  :nodes="tree"
                  node-key="_id"
                  :selected.sync="selected"
              />
            </div>
          </div>
        </transition>
      </div>
      <pop-btn v-if="notReader" class="mobile-hide" :btns="btns"/>
      <pop-hold v-if="notReader" class="mobile-only" :btns="btns"/>
      <media-modal :done="createAttach" ref="mediaModal" />
    </template>
    <template v-else>
      <div class="row justify-center">
        <q-spinner-dots :size=100 color="primary"></q-spinner-dots>
      </div>
    </template>
    <mediator
        :editEnabled="notReader"
        ref="mediator"
        @mediaEdited="mediaEdited"
        @mediaDeleted="mediaDeleted"
        @doNext="doNext"
    />
  </div>
</template>

<script>

import PopBtn from 'components/pop-btn.vue';
import PopHold from 'components/pop-hold.vue';
import viewCommon from './view-common.js';
import MediaModal from './media-modal.vue';
import Mediator from './mediator.vue';
import MediaBar from './media-bar.vue';

export default {
  name: 'hospitalview',
  props: ['transName'],
  components: {
    MediaModal,
    PopBtn,
    PopHold,
    Mediator,
    MediaBar,
  },
  extends: viewCommon,
  data() {
    return {
      selected: null,
    };
  },
  mounted() {
    this.$watch('hospital', (a) => {
      document.title = a.label;
    }, {
      immediate: true,
    });
    this.$watch('$route.query.mid', (val) => {
      console.log('HANDLER //////////////////////', val, '//', this.mediasCopy.length);
      if (val && this.mediasCopy[0]) {
        const ind = this.mediasCopy.findIndex(item => item.id === val);
        if (ind > -1) {
          this.showAttach(this.mediasCopy[ind]);
          this.$router.replace({ query: {} }); // remove query
        }
      }
    }, {
      immediate: true,
    });
  },
  computed: {
    mediasCopy() {
      return this.hospital.medias ?
        this.hospital.medias.map(media => Object.assign({}, media))
        :
        [];
    },
    btns() {
      return [
        {
          color: 'warning',
          click: this.goEdit,
          icon: 'create',
          tooltip: 'Изменить',
        },
        {
          color: 'positive',
          icon: 'fa-paperclip',
          tooltip: 'Добавить вложение',
          prefix: '+',
          click: this.chooseMedia,
        },
        {
          color: 'positive',
          click: this.doAddPerson,
          icon: 'fa-user',
          tooltip: 'Добавить персону',
          prefix: '+',
        },
        {
          color: 'positive',
          click: this.doAddInstrument,
          icon: 'icon-instrument',
          tooltip: 'Добавить инструмент',
          prefix: '+',
        },
        {
          color: 'positive',
          click: this.doAddDivision,
          icon: 'fa-sitemap',
          tooltip: 'Добавить подразделение',
          prefix: '+',
        },
        {
          color: 'warning',
          click: this.doPaste,
          icon: 'file_download',
          tooltip: `Вставить ${this.bufferLabel}`,
          hide: !this.placeFromBufferEnabled,
        },
        {
          color: 'negative',
          click: this.doDelete,
          icon: 'delete_forever',
          tooltip: 'Удалить',
          hide: !(this.tree.length === 0 && this.isAdmin),
        },
      ];
    },
    editor() {
      return this.$store.getters.userScreenName(this.hospital.editedBy);
    },
    placeFromBufferEnabled() {
      return this.isAdmin
        && !!(this.$store.state.buffer && (this.$store.state.buffer.parent_id !== this.id) && (this.$store.state.buffer.id.indexOf('case:') !== 0));
    },
    hospital() {
      return this.$store.getters.formatUnit(this.id);
    },
    formatTel() {
      return this.$utils.telStringLinks(this.hospital.telephones);
    },
    tree() {
      return this.$store.getters.subTree(this.id);
    },
  },
  methods: {
    doAddDivision() {
      this.$router.push(`/listnew/d/${this.id}`);
    },
    doAddPerson() {
      this.$router.push(`/listnew/p/${this.id}`);
    },
    doAddInstrument() {
      this.$router.push(`/listnew/i/${this.id}`);
    },
    doDelete() {
      this.$q.dialog({
        title: 'Подтвердите удаление',
        'prevent-close': true,
        message: `${this.hospital.label} будет безвозвратно удален!`,
        ok: {
          flat: true,
          color: 'negative',
          label: 'Удалить',
        },
        cancel: {
          flat: true,
          color: 'info',
          label: 'Отмена',
        },
      })
        .then(() => this.$store.dispatch('deleteUnit', this.hospital))
        .then(() => {
          if (this.$route.name === 'found') {
            this.$router.push('/found');
          } else {
            this.$router.push('/list');
          }
        })
        .catch((err) => {
          if (err) console.log(err);
        });
    },
    doPaste() {
      this.$store.dispatch('placeFromBuffer', this.id)
        .then(() => {
        })
        .catch((err) => {
          console.log('placeFromBuffer error', err);
        });
    },
  },
  watch: {
    hospital(value, oldValue) {
      console.log('hospital changed', value, oldValue);
    },
    selected(value) {
      this.$router.push(`/list/${value}`);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/hospital-view.vue